// MainContainer.tsx
import React from "react";
import "../css/container.css";

interface MainContainerProps {
  children: React.ReactNode;
  style?: string;
}

export const ContainerNoBg: React.FC<MainContainerProps> = ({
  children,
  style,
}) => {
  return <div className={"main-container" + " " + style}>{children}</div>;
};
